const lostStolenOrDamagedExpenseItemFields = [
  'infoEssentialMedicationItems',
  'infoJewelleryOrTraditionalWatchesItems',
  'infoLaptopsTabletsOrCamerasItems',
  'infoOtherUnspecifiedItems',
  'infoSpecifiedHighValueItems',
  'infoBankCardsOrTravelDocumentsItems',
  'infoCashItems',
];

const toPlainArray = (value) => {
  if (!value) return [];
  if (typeof value.toJS === 'function') return value.toJS();
  return value;
};

export const hasAnyLostStolenOrDamagedExpenseItems = (form = {}) =>
  lostStolenOrDamagedExpenseItemFields.some((field) => {
    const arr = toPlainArray(form[field]);
    return Array.isArray(arr) && arr.length > 0;
  });

export const hasAnyValidLostStolenOrDamagedExpenseItems = (form = {}) => {
  const selectedBaggageEvents = toPlainArray(form.whatHappenedToYourBaggageAndPersonalItems);
  const hasLostStolenOrDamagedSelected = Array.isArray(selectedBaggageEvents)
    && selectedBaggageEvents.includes('Lost, stolen or damaged items');

  return !hasLostStolenOrDamagedSelected || hasAnyLostStolenOrDamagedExpenseItems(form);
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.BaggageAndPersonalItems/validation.js